<template>
  <div>

		<!-- page-heading -->
		<page-heading pageTitle="PIM-CAMPAIGNS-HEADER"></page-heading>

		<div class="columns">

			<div class="col-main">

        <campaigns :embeddedView="false" :openNewCampaignModal="this.newCampaign"></campaigns>

      </div>

      <div class="col-aside">

        <affix :offset="50">
          <custom-button icon="icon-ak-hinzufuegen" name="PIM-CAMPAIGNS-BTN-NEW_CAMPAIGN" type="blue" @click.native="changeOpenModal"></custom-button>
        </affix>

      </div>

    </div>

  </div>
</template>




<script>
import Vue from 'vue';
import campaigns from './incl-pimCampaigns.vue';

export default {

  name: 'pimCampaigns',

	components: {
    campaigns
	},

	data() {

		return {
      newCampaign: false
    }

  },

  computed: {

     
  },

  created() {

  },

  methods: {

    changeOpenModal() {
      this.newCampaign = !this.newCampaign;
    },
  }
}
</script>


<style lang="scss" scoped>

</style>